import type { CSSProperties, ReactNode } from 'react';

/** Loading shapes are decorative; the owning region supplies the announcement. */
export function SkeletonBlock({
  className = '',
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return <span aria-hidden="true" className={`sk-block ${className}`} style={style} />;
}

export function Lines({ short = false }: { short?: boolean }) {
  return (
    <div className="sk-lines">
      <SkeletonBlock className="sk-line sk-line-wide" />
      <SkeletonBlock className={`sk-line ${short ? 'sk-line-short' : 'sk-line-medium'}`} />
    </div>
  );
}

export function Person({ children }: { children?: ReactNode }) {
  return (
    <div className="sk-person">
      <SkeletonBlock className="sk-avatar" />
      <Lines short />
      {children}
    </div>
  );
}

export function Rows({ count, avatar = false }: { count: number; avatar?: boolean }) {
  return (
    <div className="sk-rows">
      {Array.from({ length: count }, (_, index) => (
        <div className={`sk-row ${avatar ? 'sk-row-avatar' : ''}`} key={index}>
          {avatar && <SkeletonBlock className="sk-avatar" />}
          <Lines />
          <SkeletonBlock className="sk-row-end" />
        </div>
      ))}
    </div>
  );
}

export function Form({ count }: { count: number }) {
  return (
    <div className="sk-form">
      {Array.from({ length: count }, (_, index) => (
        <div className="sk-field" key={index}>
          <SkeletonBlock className="sk-line sk-line-short" />
          <SkeletonBlock className="sk-control" />
        </div>
      ))}
    </div>
  );
}

export function PageHeading({ action = false }: { action?: boolean } = {}) {
  return (
    <div className="sk-page-heading">
      <div className="sk-page-heading-copy">
        <SkeletonBlock className="sk-line sk-page-eyebrow" />
        <SkeletonBlock className="sk-title" />
        <SkeletonBlock className="sk-line sk-line-medium" />
      </div>
      {action && <SkeletonBlock className="sk-control" />}
    </div>
  );
}
